import { toast } from "react-toastify";
import * as CONFIG from "../Components/_config";
import axios from "axios";
import { handleErrorResponse } from "../helper";

const fetchChartData = async (endpoint, params) => {
  try {
    const response = await axios({
      method: "get",
      url: `${CONFIG.API_URL}${endpoint}`,
      headers: CONFIG.config_head.headers,
      params
    });

    return response.status === 200 ? response.data : response;
  } catch (error) {
    handleErrorResponse(error);
    if (error.response.status !== 403) {
      toast.error(error.response.data.Message);
    }
    return error.response;
  }
};

export const getWeeklyUnitSold = (params) =>
  fetchChartData("brand/chart-data/units-sold", params);

export const getWeeklyRevenue = (params) =>
  fetchChartData("brand/chart-data/revenue", params);

export const getMonthlyUnitSold = (params) =>
  fetchChartData("brand/chart-data/units-sold-monthly", params);

export const getMonthlyRevenue = (params) =>
  fetchChartData("brand/chart-data/revenue-monthly", params);

export const getStoresByMonth = (params) =>
  fetchChartData("brand/chart-data/stores-by-month", params);

export const getRetailersByMonth = (params) =>
  fetchChartData("brand/chart-data/retailers-by-month", params);

export const getShopperCount = (params) =>
  fetchChartData("brand/chart-data/shopper-count", params);

export const getFilter = (cacid) =>
  fetchChartData(`brand/chart-data/filters?cacid=${cacid}`);

export const getFilterCategoryid = (categoryid) =>
  fetchChartData(`brand/chart-data/filters-category?categoryid=${categoryid}`);

export const getYearUnitcategory = (params) =>
  fetchChartData("brand/chart-data/filters-category", params);

export const getYearUnitSold = (params) =>
  fetchChartData("brand/chart-data/units-sold-monthly-category", params);

export const getYearRevenue = (params) =>
  fetchChartData("brand/chart-data/revenue-monthly-category", params);

// Redemption filters
export const getRedemptionFilters = (type,brandGuid) =>
  fetchChartData("coupon/find-redemptions-filters?type="+type+"&brandGuid="+brandGuid, { type });

// Redemption search
export const findRedemptions = (params) =>fetchChartData("coupon/find-redemptions-result", params);
